import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import { useMetaSetup } from '../../context/MetaSetupContext';
import "../../assets/css/tablesShadow.css"

interface OrgWabaTableProps {
    orgId: string;
}

const OrgWabaTable: React.FC<OrgWabaTableProps> = ({ orgId }) => {
    const { orgWabaData } = useMetaSetup();
    const [wabaAccounts, setWabaAccounts] = useState<any[]>([]);

    useEffect(() => {
        const orgData = orgWabaData.find(org => org.orgId === orgId);
        if (orgData) {
            setWabaAccounts(orgData.wabaDetails || []);
        } else {
            setWabaAccounts([]);
        }
    }, [orgId, orgWabaData]);

    const columns = [
        {
            title: 'WABA Name',
            dataIndex: 'subdomain',
            key: 'subdomain',
            render: (text: string) => text || 'N/A'
        },
        {
            title: 'WABA Number',
            dataIndex: 'wabaNumber',
            key: 'wabaNumber',
        },
        {
            title: 'Conversion API',
            dataIndex: 'metaConversionApiStatus',
            key: 'metaConversionApiStatus',
            render: (status: boolean) => (
                <Tag color={status ? 'green' : 'red'}>
                    {status ? 'ENABLED' : 'DISABLED'}
                </Tag>
            ),
        },
    ];

    return (
        <div className="p-4 bg-gray-50 rounded">
            <h3 className="mb-2 font-medium text-gray-700">WABA Accounts</h3>
            <Table
                columns={columns}
                dataSource={wabaAccounts}
                rowKey="wabaId"
                pagination={false}
                size="small"
            />
        </div>
    );
};

export default OrgWabaTable;
